import styled from 'styled-components';
import device from '_constants/DEVICES';

export const TimeContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  padding-right: 10px;
  white-space: nowrap;

  @media ${device.tablet} {
    display: none;
  }
`;
